import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/students/all-students',
)({
  component: () => <Outlet />,
});
